import { translationUrl } from "../config";

export async function fetchTranslations(lang: string) {
  const url = translationUrl(lang);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch translations for ${lang}`);
  const data = await response.json();
  return data || {};
}
